'use strict'

const u = require('universalify').fromCallback
module.exports = {
  copy: u(require('./copy'))
}



//////////////////
// WEBPACK FOOTER
// ./~/ethpm/~/fs-extra/lib/copy/index.js
// module id = 1281
// module chunks = 0 1